import { defineStore } from 'pinia'
import { ref } from 'vue'
import Cache from '@/utils/cache'

export const useOtherStore = defineStore('other', () => {
    const returnUrl = ref('')
    const systemInfo = ref(Cache.get('systemInfo'))
    const refreshToken = ref(0)
    const refreshConfig = ref(0)
    const refreshMenus = ref(0)

    return { returnUrl, systemInfo, refreshToken, refreshConfig, refreshMenus }
})
